import { SvgIcon } from '@mui/material';

export default function PavementManagementIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        d='M4 19L8 5M16 5L20 19M12 8V6M12 13V11M12 18V16'
        stroke='currentColor'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
    </SvgIcon>
  );
}
